<template>
  <div class="principal-hoja-prueba" data-app>
    <titulo-seccion titulo="HOJA DE PRUEBA"></titulo-seccion>
    <div class="container contenedor-hoja-prueba">
      <div class="row row-cols-lg-12 mt-3">
        <strong class="titulo-seccion">Verificación de datos</strong>
        <p class="parrafo-instrucciones mt-2">
          Debes verificar correctamente cada uno de los campos, ya que es
          necesario que cada uno de ellos, estén correctos, son campos editables
          así que puedes modificarlos para corregirlos o cambiarlos.
        </p>
      </div>
      <form
        class="requiere-validacion"
        novalidate
        ref="formularioConfirmacionDatosBasicos"
        v-bind:class="{ 'was-validated': formularioValidadoDatosBasicos }"
      >
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba"
              >Nombre del Titular</label
            >
            <input
              id="nombre"
              type="text"
              class="form-control campo-basico"
              placeholder="Nombre(s)"
              v-model="datosBasicos.nombres"
              required
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              El nombre del titular es requerido.
            </div>
          </div>
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">Apellido Paterno</label>
            <input
              type="text"
              class="form-control campo-basico"
              placeholder="Apellido paterno"
              v-model="datosBasicos.apellidoPaterno"
              required
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              El apellido paterno del titular es requerido.
            </div>
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">Apellido Materno</label>
            <input
              id="nombre"
              type="text"
              class="form-control campo-basico"
              placeholder="Apellido materno"
              v-model="datosBasicos.apellidoMaterno"
            />
          </div>
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">Monto</label>
            <VueAutonumeric
              class="form-control campo-basico"
              :options="{
                currencySymbol: '$',
                decimalPlaces: '2',
                minimumValue: '0',
                maximumValue: '15000000',
              }"
              :placeholder="'Monto'"
              v-model="datosBasicos.monto"
              disabled
            ></VueAutonumeric>
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">RFC:</label>
            <input
              maxlength="13"
              id="nombre"
              type="text"
              class="form-control campo-basico"
              placeholder="RFC"
              v-model="datosSolicitudFisica.rfc"
              required
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              El rfc es requerido.
            </div>
          </div>
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">Servicio</label>
            <DropDown
              :disabled="this.soloLectura"
              placeholder="Selecciona ¿Qué servicio deseas?* "
              :arreglo="this.catalogos.servicios"
              llave="value"
              valor="value"
              texto="text"
              v-model="datosSolicitud.servicio"
              :requerido="true"
            ></DropDown>
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              El servicio es requerido.
            </div>
          </div>
        </div>
        <div class="row row-cols-lg-12 mt-4">
          <label
            class="form-label label-hoja-prueba"
            style="text-align: initial"
            >Domicilio particular:</label
          >
          <div class="col-lg-6 campo-solicitud">
            <input
              id="nombre"
              type="text"
              class="form-control campo-basico"
              placeholder="Calle *"
              v-model="DatosUbicacionGeneralParticular.calle"
              required
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              La calle es requerida
            </div>
          </div>
          <div class="col-lg-6 campo-solicitud">
            <input
              type="text"
              class="form-control campo-basico"
              placeholder="Número *"
              v-model="DatosUbicacionGeneralParticular.numero"
              required
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              El número es requerido.
            </div>
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <input
              :disabled="this.soloLectura"
              placeholder="Código Postal * "
              type="number"
              onkeydown="return event.keyCode !== 69"
              onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
              required
              min="0"
              class="form-control campo-basico"
              v-model="codigoPostalParticular"
              pattern="[0-9]{5}"
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              El código postal es requerido
            </div>
          </div>
          <div class="col-lg-6 campo-solicitud">
            <input
              placeholder="Estado *"
              type="text"
              class="form-control campo-basico"
              v-model="direccion.estado"
              disabled
              required
            />
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <input
              placeholder="Delegación o municipio *"
              type="text"
              class="form-control campo-basico"
              v-model="direccion.ciudad"
              disabled
              required
            />
          </div>
          <div
            class="col-lg-6 campo-solicitud"
            v-if="
              (codigoPostalValido == true && catalogos.colonias.length > 0) ||
                coloniaExistenteParticular != null
            "
          >
            <DropDown
              :disabled="this.soloLectura"
              placeholder="Selecciona una colonia *"
              :arreglo="this.catalogos.colonias"
              llave="coloniaId"
              valor="coloniaId"
              texto="descripcion"
              v-model="DatosUbicacionParticular.coloniaId"
              :requerido="true"
            ></DropDown>
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              La colonia es requerida.
            </div>
          </div>
          <div class="col-lg-6 campo-solicitud" v-else>
            <DropDown
              disabled
              placeholder="Selecciona una colonia *"
              :arreglo="this.catalogos.colonias"
              llave="coloniaId"
              valor="coloniaId"
              texto="descripcion"
              v-model="DatosUbicacionParticular.coloniaId"
              :requerido="true"
            ></DropDown>
          </div>
        </div>
        <div v-if="this.DatosUbicacionGeneralOficina.ubicacionId != 0">
          <div class="row row-cols-lg-12 mt-4">
            <label
              class="form-label label-hoja-prueba"
              style="text-align: initial"
              >Domicilio de trabajo:</label
            >
            <div class="col-lg-6 campo-solicitud">
              <input
                id="nombre"
                type="text"
                class="form-control campo-basico"
                placeholder="Calle *"
                v-model="DatosUbicacionGeneralOficina.calle"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                La calle es requerida.
              </div>
            </div>
            <div class="col-lg-6 campo-solicitud">
              <input
                type="text"
                class="form-control campo-basico"
                placeholder="Número *"
                v-model="DatosUbicacionGeneralOficina.numero"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El número es requerido.
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 campo-solicitud">
              <input
                :disabled="this.soloLectura"
                placeholder="Código Postal * "
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                required
                min="0"
                class="form-control campo-basico"
                v-model="codigoPostalOficina"
                pattern="[0-9]{5}"
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El código postal es requerido.
              </div>
            </div>
            <div class="col-lg-6 campo-solicitud">
              <input
                placeholder="Estado *"
                type="text"
                class="form-control campo-basico"
                v-model="direccionEmpresa.estado"
                disabled
                required
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 campo-solicitud">
              <input
                placeholder="Delegación o municipio *"
                type="text"
                class="form-control campo-basico"
                v-model="direccionEmpresa.ciudad"
                disabled
                required
              />
            </div>
            <div
              class="col-lg-6 campo-solicitud"
              v-if="
                (codigoPostalValidoEmpresa == true &&
                  catalogos.coloniasEmpresa.length > 0) ||
                  coloniaExistenteOficina != null
              "
            >
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Selecciona una colonia *"
                :arreglo="this.catalogos.coloniasEmpresa"
                llave="coloniaId"
                valor="coloniaId"
                texto="descripcion"
                v-model="DatosUbicacionOficina.coloniaId"
                :requerido="true"
              ></DropDown>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                La colonia es requerida.
              </div>
            </div>
            <div class="col-lg-6 campo-solicitud" v-else>
              <DropDown
                disabled
                placeholder="Selecciona una colonia *"
                :arreglo="this.catalogos.coloniasEmpresa"
                llave="coloniaId"
                valor="coloniaId"
                texto="descripcion"
                v-model="DatosUbicacionOficina.coloniaId"
                :requerido="true"
              ></DropDown>
            </div>
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div
            class="col-lg-6 campo-solicitud"
            style="display: flex; flex-direction: column"
          >
            <label
              class="form-label label-hoja-prueba"
              style="text-align: initial"
              >Fecha de nacimiento</label
            >
            <input-fecha
              idioma="es-MX"
              v-model="datosSolicitud.fechaNacimiento"
            ></input-fecha>
          </div>
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">Teléfono de casa</label>
            <input
              :disabled="this.soloLectura"
              placeholder="Teléfono de casa"
              type="number"
              onkeydown="return event.keyCode !== 69"
              onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
              min="0"
              class="form-control campo-basico"
              v-model="PuntoContactoGeneral.telefonoFijo.valor"
            />
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba"
              >Teléfono de oficina</label
            >
            <input
              :disabled="this.soloLectura"
              placeholder="Teléfono de oficina "
              type="number"
              onkeydown="return event.keyCode !== 69"
              onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
              min="0"
              class="form-control campo-basico"
              v-model="PuntoContactoGeneral.telefonoFijoOficina.valor"
            />
          </div>
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba"
              >Correo electrónico</label
            >
            <input
              placeholder="Correo electrónico *"
              type="email"
              class="form-control campo-basico"
              v-model="PuntoContactoGeneral.correo1.valor"
              disabled
            />
          </div>
        </div>
        <button
          ref="envioFormularioDatosBasicos"
          @click.prevent="ValidaFormulario"
          class="btn btn-primary"
          hidden
          type="submit"
        >
          submit
        </button>
      </form>
      <div
        class="row row-cols-lg-12 mt-4"
        v-if="tipoPersona != 6 && tipoPersona != 7"
      >
        <label class="form-label label-hoja-prueba" style="text-align: initial"
          >Beneficiarios:</label
        >
        <div
          v-for="(formBeneficiario, index) in FormBeneficiarios"
          v-bind:key="index"
        >
          <form novalidate>
            <div class="row row-cols-lg-12">
              <div class="col-lg-6 campo-solicitud">
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Nombres(s) *"
                  class="form-control campo-basico"
                  v-model="formBeneficiario.nombre"
                  required
                />
              </div>
              <div class="col-lg-6 campo-solicitud">
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Apellido paterno *"
                  v-model="formBeneficiario.apellidoPaterno"
                  class="form-control campo-basico"
                  required
                />
              </div>
            </div>
            <div class="row row-cols-lg-12 row-ap-materno-benfeficiario">
              <div class="col-lg-6 campo-solicitud">
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Apellido materno"
                  v-model="formBeneficiario.apellidoMaterno"
                  class="form-control campo-basico"
                />
              </div>
              <div class="col-lg-6 campo-solicitud">
                <DropDown
                  :disabled="soloLectura"
                  placeholder="Selecciona el tipo de relación *"
                  :arreglo="catalogos.parentescos"
                  llave="value"
                  valor="value"
                  texto="text"
                  v-model="formBeneficiario.parentesco"
                  :requerido="true"
                ></DropDown>
              </div>
            </div>
            <div class="row row-cols-lg-12 row-ap-materno-benfeficiario">
              <div class="col-lg-6 campo-solicitud">
                <div class="input-group">
                  <input
                    :disabled="soloLectura"
                    @keyup="LimitarPorcentaje(index)"
                    type="number"
                    onkeydown="return event.keyCode !== 69"
                    onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                    min="0"
                    class="form-control campo-basico"
                    v-model="formBeneficiario.porcentaje"
                    placeholder="Porcentaje *"
                    required
                  />
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text"
                      style="
                        border-radius: 0px;
                        border: 1px solid;
                        font-family: 'Poppins';
                      "
                      >%</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-6 campo-solicitud">
                <input
                  :disabled="soloLectura"
                  type="number"
                  onkeydown="return event.keyCode !== 69"
                  onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                  min="0"
                  placeholder="Teléfono móvil (10 dígitos)*"
                  v-model="formBeneficiario.telefono"
                  class="form-control campo-basico"
                  required
                />
              </div>
            </div>
            <div
              class="col-lg-12 col-sm-12"
              style="text-align: end"
              v-if="soloLectura == false"
            >
              <strong
                v-if="
                  FormBeneficiarios.length > 1 &&
                    CamposActualesVacios(index) == false
                "
                class="etiqueta-nuevo-documento"
                @click.prevent="EliminarBeneficiarioTest(index)"
                >Eliminar beneficiario</strong
              >
            </div>
          </form>
        </div>
        <div
          class="col-lg-12 col-sm-12 col-agregar-beneficiario"
          style="text-align: end"
        >
          <label
            class="etiqueta-nuevo-documento"
            @click.prevent="AgregarFormBeneficiario(false)"
            >Agregar otro beneficiario</label
          >
        </div>
      </div>
      <form
        v-if="this.DatosUbicacionGeneralFiscal.ubicacionId != 0"
        class="requiere-validacion"
        novalidate
        ref="formularioConfirmacionDatosFiscales"
        v-bind:class="{ 'was-validated': formularioValidadoDatosFiscales }"
      >
        <div class="row row-cols-lg-12 mt-4">
          <label
            class="form-label label-hoja-prueba"
            style="text-align: initial"
            >Domicilio fiscal:</label
          >
          <div class="col-lg-6 campo-solicitud">
            <input
              id="nombre"
              type="text"
              class="form-control campo-basico"
              placeholder="Calle *"
              v-model="DatosUbicacionGeneralFiscal.calle"
              required
            />
          </div>
          <div class="col-lg-6 campo-solicitud">
            <input
              type="text"
              class="form-control campo-basico"
              placeholder="Número *"
              v-model="DatosUbicacionGeneralFiscal.numero"
              required
            />
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <input
              :disabled="this.soloLectura"
              placeholder="Código Postal * "
              type="number"
              onkeydown="return event.keyCode !== 69"
              onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
              required
              min="0"
              class="form-control campo-basico"
              v-model="codigoPostalFiscal"
              pattern="[0-9]{5}"
            />
          </div>
          <div class="col-lg-6 campo-solicitud">
            <input
              placeholder="Estado *"
              type="text"
              class="form-control campo-basico"
              v-model="direccionFiscal.estado"
              disabled
              required
            />
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <input
              placeholder="Delegación o municipio *"
              type="text"
              class="form-control campo-basico"
              v-model="direccionFiscal.ciudad"
              disabled
              required
            />
          </div>
          <div
            class="col-lg-6 campo-solicitud"
            v-if="
              (codigoPostalValidoFiscal == true &&
                catalogos.coloniasFactura.length > 0) ||
                coloniaExistenteFiscal != null
            "
          >
            <DropDown
              :disabled="this.soloLectura"
              placeholder="Selecciona una colonia *"
              :arreglo="this.catalogos.coloniasFactura"
              llave="coloniaId"
              valor="coloniaId"
              texto="descripcion"
              v-model="DatosUbicacionFiscal.coloniaId"
              :requerido="true"
            ></DropDown>
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              La colonia es requerida.
            </div>
          </div>
          <div class="col-lg-6 campo-solicitud" v-else>
            <DropDown
              :disabled="this.soloLectura"
              placeholder="Selecciona una colonia *"
              :arreglo="this.catalogos.coloniasFactura"
              llave="coloniaId"
              valor="coloniaId"
              texto="descripcion"
              v-model="DatosUbicacionFiscal.coloniaId"
              :requerido="true"
            ></DropDown>
          </div>
        </div>
        <div class="row row-cols-lg-12" style="text-align: left">
          <p>
            *Los datos fiscales solo podrán ser los del titular del contrato
            aperturado por HIR Casa.
          </p>
        </div>
        <button
          ref="envioFormularioDatosFiscales"
          @click.prevent="ValidaFormulario"
          class="btn btn-primary"
          hidden
          type="submit"
        >
          submit
        </button>
      </form>
      <div class="row row-cols-lg-12 row-confirmar" v-if="PuedeAprobar">
        <button
          v-if="confirmandoDatos"
          type="button"
          disabled
          class="boton-primario boton-confirmar"
        >
          <v-progress-circular
            indeterminate
            size="30"
            color="primary"
          ></v-progress-circular>
        </button>
        <button
          v-else-if="!confirmandoDatos"
          type="button"
          class="boton-primario boton-confirmar"
          @click.prevent="ConfirmarInformacion()"
        >
          Confirmar
        </button>
        <button
          v-else
          type="button"
          :disabled="true"
          class="boton-primario boton-confirmar"
        >
          Confirmar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
//Plugins
import axios from "axios";
import servicios from "../../../servicios/service.js";
//Componentes
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import VueAutonumeric from "../../../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric.vue";
import DropDown from "../components/DropDown.vue";
import InputFecha from "../components/InputFecha.vue";
//Mixins
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";
import MixinHojaPrueba from "../Mixins/MixinHojaPrueba.js";

//Rutas API
//const rutaConsultarDatosHojaPrueba =
//"/api/Master/HojaPrueba/ObtenerDatosHojaPrueba";
const rutaEnviarACore = "/api/Master/PreAutorizacion/EnviarACore";
const rutaEnviarACoreAdicionales =
  "/api/Master/PreAutorizacion/EnviarACoreAdicionales";

const rutaObtenerFiguraAdicional =
  "/api/Master/FiguraAdicional/ListarFiguraAdicional";

export default {
  name: "HojaPrueba",
  mixins: [mixinSolicitudInscripcion, MixinHojaPrueba],
  components: {
    TituloSeccion,
    VueAutonumeric,
    DropDown,
    InputFecha,
  },
  mounted() {
    this.ProspectoId = this.$store.getters.prospectoId;
    this.tipoPersona = this.$store.getters.tipoPersona;
    this.tipoUsuario = this.$store.getters.tipoUsuario;

    if (this.$store.getters.modoPago == 2) {
      this.modoPago = 2;
    } else {
      this.modoPago = 1;
    }

    //Prospecto = 3                Master Operativo = 8
    if (this.tipoUsuario == 3 || this.tipoUsuario == 8) {
      this.esProspecto = true;
    }

    this.ValidarAprobadoresHojaPrueba(this.tipoUsuario);

    this.CargarServicios(false);
    this.CargarParentescos(false);
    //Carga de datos de la hoja de prueba
    this.CargarDatosHojaPrueba(this.ProspectoId, this.tipoPersona);
    this.ConsultarSolicitudes(this.ProspectoTipoUsuarioId, false);
    this.ListarFigurasAdicionales(this.ProspectoId, this.tipoPersona);
  },
  data() {
    return {
      PuedeAprobar: false,
      ProspectoId: null,
      SolicitudId: null,
      tipoPersona: null,
      tipoUsuario: null,
      solicitudExistenteId: null,
      tieneAdicionales: false,
      adicionalesEnviadosCore: 0,
      figuras: [],
      catalogos: {
        servicios: [],
        colonias: [],
        coloniasEmpresa: [],
        coloniasFactura: [],
      },
      //Datos basicos
      datosBasicos: {
        nombres: null,
        apellidoPaterno: null,
        apellidoMaterno: null,
        monto: null,
      },
      datosSolicitud: {
        solicitudId: null,
        fechaNacimiento: null,
        servicio: null,
      },
      datosSolicitudFisica: {
        rfc: null,
      },
      DatosUbicacionGeneralParticular: {
        ubicacionId: 0,
        prospectoId: null,
        tipoUbicacion: 0,
        calle: null,
        numero: null,
        direccionFacturacion: false,
      },
      DatosUbicacionGeneralOficina: {
        ubicacionId: 0,
        prospectoId: null,
        tipoUbicacion: 1,
        calle: null,
        numero: null,
        direccionFacturacion: false,
      },
      DatosUbicacionGeneralFiscal: {
        ubicacionId: 0,
        prospectoId: null,
        tipoUbicacion: 2,
        calle: null,
        numero: null,
        direccionFacturacion: false,
      },
      DatosUbicacionParticular: {
        ubicacionId: null,
        coloniaId: null,
        coloniaIdOriginal: null,
      },
      DatosUbicacionOficina: {
        ubicacionId: null,
        coloniaId: null,
        coloniaIdOficinaOriginal: null,
      },
      DatosUbicacionFiscal: {
        ubicacionId: null,
        coloniaId: null,
        coloniaIdFiscalOriginal: null,
      },
      //auxiliares
      direccion: {
        ciudad: null,
        estado: null,
      },
      direccionEmpresa: {
        ciudad: null,
        estado: null,
      },
      direccionFiscal: {
        ciudad: null,
        estado: null,
      },
      PuntoContactoGeneral: {
        telefonoFijo: {
          puntoContactoId: 0,
          valor: null,
        },
        telefonoMovil: {
          puntoContactoId: 0,
          valor: null,
        },
        correo1: {
          puntoContactoId: 0,
          valor: null,
        },
        correo2: {
          puntoContactoId: 0,
          valor: null,
        },
        telefonoFijoOficina: {
          puntoContactoId: 0,
          valor: null,
        },
      },
      FormBeneficiarios: [
        {
          beneficiarioId: null,
          nombre: null,
          apellidoPaterno: null,
          apellidoMaterno: null,
          parentesco: null,
          porcentaje: null,
          telefono: null,
        },
      ],
      codigoPostalOficina: null,
      codigoPostalParticular: null,
      codigoPostalFiscal: null,
      codigoPostalValido: false,
      codigoPostalValidoEmpresa: false,
      codigoPostalValidoFiscal: false,
      coloniaExistenteParticular: null,
      coloniaExistenteOficina: null,
      coloniaExistenteFiscal: null,
      rfcValido: false,
      soloLectura: false,
      formularioValidadoDatosBasicos: false,
      formularioValidadoDatosFiscales: false,
      confirmandoDatos: false,
      modoPago: null,
      esProspecto: false,
    };
  },
  computed: {
    camposVaciosBeneficiarioForm: function() {
      let llaves = Object.keys(
        this.FormBeneficiarios[this.FormBeneficiarios.length - 1]
      );
      let vacios = 0;
      llaves.forEach((llave) => {
        if (llave != "apellidoMaterno" && llave != "beneficiarioId") {
          if (
            this.FormBeneficiarios[this.FormBeneficiarios.length - 1][llave] ===
              "" ||
            this.FormBeneficiarios[this.FormBeneficiarios.length - 1][llave] ===
              null
          ) {
            vacios++;
          }
        }
      });
      return vacios > 0 ? true : false;
    },
  },
  methods: {
    ConfirmarInformacion() {
      if (this.PuedeAprobar === false) {
        return;
      }
      this.$fire({
        title: "Confirmación",
        html:
          "Confirmo que he leído y verificado que los datos mostrados son correctos. <br>Autorizo para que con estos datos, se genere el contrato.",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Volver",
      }).then((result) => {
        if (result.value) {
          this.$refs.envioFormularioDatosBasicos.click();
        }
      });
    },
    ValidaFormulario() {
      let sonValidos = false;
      //Valida datos básicos
      let esValidoDatosBasicos = false;
      this.formularioValidadoDatosBasicos = true;
      esValidoDatosBasicos = this.$refs.formularioConfirmacionDatosBasicos.checkValidity();

      if (this.DatosUbicacionGeneralFiscal.ubicacionId != 0) {
        let esValidoDatosFiscales = false;
        this.formularioValidadoDatosFiscales = true;
        esValidoDatosFiscales = this.$refs.formularioConfirmacionDatosFiscales.checkValidity();
        sonValidos =
          esValidoDatosBasicos && esValidoDatosFiscales ? true : false;
        this.confirmandoDatos = false;
      } else {
        sonValidos = esValidoDatosBasicos;
        this.confirmandoDatos = true;
      }

      if (sonValidos) {
        this.confirmandoDatos = true;
        if (this.datosSolicitud.fechaNacimiento == null) {
          this.AlertaEmbajadores(
            "Por favor indica la fecha de nacimiento",
            true
          );
          return;
        }
        if (this.ValidarRFC() == false) {
          this.AlertaEmbajadores(
            "Por favor verifica que el formato de tu RFC sea válido.",
            true
          );
          return;
        }
        if (this.tipoPersona != 6 && this.tipoPersona != 7) {
          if (this.FormBeneficiarios.length <= 0) {
            this.AlertaEmbajadores(
              "Debe ingresar al menos un beneficiario.",
              true
            );
            return;
          } else {
            if (this.SumaPorcentajes() < 100) {
              this.AlertaEmbajadores(
                "Los beneficiarios deben sumar un total de 100%",
                true
              );
              return;
            }
          }
        }

        if (this.tipoPersona != 6 && this.tipoPersona != 7) {
          let camposVaciosBeneficiarios = 0;
          for (var beneficiario of this.FormBeneficiarios) {
            if (
              this.CamposActualesVacios(
                this.FormBeneficiarios.indexOf(beneficiario)
              )
            ) {
              camposVaciosBeneficiarios++;
            }
          }

          if (camposVaciosBeneficiarios > 0) {
            this.AlertaEmbajadores(
              "No has llenado todos los campos requeridos en algunos de tus beneficiarios.",
              true
            );
            return;
          }
          if (this.FormBeneficiarios.length > 0) {
            this.GuardarBeneficiariosTest(this.datosSolicitud.solicitudId);
          }
        }

        this.ActualizarDatosBasicos();
        this.GuardarUbicacionGeneralParticular();
        if (
          this.DatosUbicacionGeneralOficina.ubicacionId != 0 &&
          this.DatosUbicacionGeneralOficina.ubicacionId != null
        ) {
          this.GuardarUbicacionGeneralOficina();
        }
        if (
          this.DatosUbicacionFiscal.ubicacionId != 0 &&
          this.DatosUbicacionFiscal.ubicacionId != null
        ) {
          this.GuardarUbicacionGeneralFiscal();
        }
        this.GuardarPuntosDeContacto(true, false); //REVISAR QUE NO ELIMINE PUNTOS DE CONTACTO NO EXISTENTES EN ESTE FORM

        if (
          this.tipoPersona == 0 ||
          this.tipoPersona == 1 ||
          this.tipoPersona == 2
        ) {
          this.$fire({
            title: "Confirmación",
            text:
              this.modoPago == 2
                ? this.tipoPersona == 2
                  ? "Your data has been successfully confirmed, you will be redirected to your Welcome Kit."
                  : "Se confirmaron correctamente tus datos, serás redirigido a tu Kit de Bienvenida"
                : this.tipoPersona == 2
                ? "Your information has been successfully confirmed, we will validate your proof of payment."
                : "Se confirmaron correctamente tus datos, validaremos tu comprobante de pago.",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
            allowOutsideClick: false,
          }).then((result) => {
            if (result.value) {
              this.EnviarACore();
            }
          });
        }
      } else {
        this.confirmandoDatos = false;
      }
    },
    ValidarRFC() {
      var regExpCHRfc = /^([A-ZÑ]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([0-9-A-Z\\d]{3})?$/;
      return regExpCHRfc.test(this.datosSolicitudFisica.rfc.toUpperCase());
    },
    LimitarPorcentaje(index) {
      this.FormBeneficiarios[index].porcentaje =
        this.FormBeneficiarios[index].porcentaje != null
          ? parseFloat(this.FormBeneficiarios[index].porcentaje)
          : 0;
      if (this.FormBeneficiarios.length == 1) {
        if (this.FormBeneficiarios[0].porcentaje > 100)
          this.FormBeneficiarios[0].porcentaje = 100;
      } else {
        if (this.SumaPorcentajes() > 100) {
          let resta =
            this.SumaPorcentajes() - this.FormBeneficiarios[index].porcentaje;
          let faltante = 100 - resta;
          this.FormBeneficiarios[index].porcentaje = faltante;
        }
      }
    },
    ListarFigurasAdicionales(prospectoId, tipoPersona) {
      const parametroProspecto = {
        params: {
          prospectoId: prospectoId,
          tipoPersona: tipoPersona,
        },
      };
      axios
        .get(rutaObtenerFiguraAdicional, parametroProspecto)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.figuras = resp.data.data;
            if (this.figuras.length > 0) {
              this.tieneAdicionales = true;
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje);
          } else {
            this.AlertaEmbajadores(resp.data.mensaje);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    EnviarACore() {
      axios
        .post(
          rutaEnviarACore +
            "/?prospectoId=" +
            this.ProspectoId +
            "&solicitudId=" +
            this.SolicitudId +
            "&aplicacionId=0" +
            "&modoPago=" +
            this.modoPago
        )
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.$store.commit("setModoPago", null);
            this.AlertaEmbajadores(resp.data.mensaje, true);
            if (this.tipoUsuario === 3)
              this.$router.push({ path: "SeguimientoProspecto" });
            else this.$router.push({ path: "AdministracionDeProspectos" });
          } else if (resp.data.estado === 1) {
            this.confirmandoDatos = false;
            this.$fire({
              title: "Aviso",
              text: resp.data.mensaje,
              showConfirmButton: true,
              showCancelButton: false,
              confirmButtonText: "Aceptar",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.value) {
                if (this.tipoUsuario === 3)
                  this.$router.push({ path: "SeguimientoProspecto" });
                else this.$router.push({ path: "AdministracionDeProspectos" });
              }
            });
            if (this.modoPago == 2) {
              this.confirmandoDatos = false;
              if (this.tipoUsuario === 3)
                this.$router.push({ path: "SeguimientoProspecto" });
              else this.$router.push({ path: "AdministracionDeProspectos" });
            }
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    EnviarACoreAdicionales(prospectoId, tipoFigura) {
      if (tipoFigura == 4 || tipoFigura == 5) {
        axios
          .post(rutaEnviarACoreAdicionales + "/?prospectoId=" + prospectoId)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.adicionalesEnviadosCore++;
            } else if (resp.data.estado === 1) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
              this.adicionalesEnviadosCore--;
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
            return false;
          });
      }
      this.adicionalesEnviadosCore++;
    },
    ValidarAprobadoresHojaPrueba(tipoUsuario) {
      //pueden aprobar
      /*
        Prospecto Activo = 3
        Administrador = 5
        Master Operativo = 8
        Administrador Comercial = 10
      */
      const aprobadoresHojaPrueba = [3, 5, 8, 10];
      this.PuedeAprobar = aprobadoresHojaPrueba.includes(tipoUsuario);
    },
  },
  watch: {
    "PuntoContactoGeneral.telefonoFijo.valor": function() {
      this.PuntoContactoGeneral.telefonoFijo.valor = servicios.LimitarTelefonoLocal(
        this.PuntoContactoGeneral.telefonoFijo.valor
      );
    },
    FormBeneficiarios: {
      handler: function(value) {
        value.forEach((item) => {
          item.porcentaje = servicios.EvitarNegativos(item.porcentaje);
          item.telefono = servicios.LimitarTelefonoLocal(item.telefono);
        });
      },
      deep: true,
    },
    codigoPostalFiscal: function() {
      if (this.codigoPostalFiscal == "") {
        this.direccionFiscal.ciudad = "NO DETECTADO";
        this.direccionFiscal.estado = "NO DETECTADO";
        this.codigoPostalValidoFiscal = false;
        this.catalogos.coloniasFactura = [];
        this.DatosUbicacionFiscal.coloniaId = null;
      }
      if (this.codigoPostalFiscal.length > 5) {
        this.codigoPostalFiscal = this.codigoPostalFiscal
          .toString()
          .substring(0, 5);
      }
      if (this.codigoPostalFiscal.length == 5) {
        this.ConsultarCodigoPostal(this.codigoPostalFiscal, 2);
      }
    },
    codigoPostalParticular: function() {
      if (this.codigoPostalParticular == "") {
        this.direccion.ciudad = "NO DETECTADO";
        this.direccion.estado = "NO DETECTADO";
        this.codigoPostalValido = false;
        this.catalogos.colonias = [];
        this.DatosUbicacionParticular.coloniaId = null;
      }
      if (this.codigoPostalParticular.length > 5) {
        this.codigoPostalParticular = this.codigoPostalParticular
          .toString()
          .substring(0, 5);
      }
      if (this.codigoPostalParticular.length == 5) {
        this.ConsultarCodigoPostal(this.codigoPostalParticular, 0);
      }
    },
    codigoPostalOficina: function() {
      if (this.codigoPostalOficina == "") {
        this.direccionEmpresa.ciudad = "NO DETECTADO";
        this.direccionEmpresa.estado = "NO DETECTADO";
        this.codigoPostalValidoEmpresa = false;
        this.catalogos.coloniasEmpresa = [];
        this.DatosUbicacionOficina.coloniaId = null;
      }
      if (this.codigoPostalOficina.length > 5) {
        this.codigoPostalOficina = this.codigoPostalOficina
          .toString()
          .substring(0, 5);
      }
      if (this.codigoPostalOficina.length == 5) {
        this.ConsultarCodigoPostal(this.codigoPostalOficina, 1);
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";
</style>
